/**
 * API DIFFERENCES vs ../toggle.tsx (shadcn):
 * Same API
 */
/** biome-ignore-all lint/style/useComponentExportOnlyModules: storybook export pattern */
'use client'

import { Toggle as TogglePrimitive } from '@base-ui/react/toggle'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/utils'
import { Children } from 'react'

const toggleVariants = cva(
  "focus-visible:ring-primary/80 focus-visible:ring-offset-surface-1 data-pressed:bg-border data-pressed:text-on-surface relative inline-flex shrink-0 cursor-pointer items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap outline-none select-none focus-visible:ring-4 focus-visible:ring-offset-4 disabled:cursor-not-allowed disabled:opacity-60 pointer-coarse:after:absolute pointer-coarse:after:size-full pointer-coarse:after:min-h-11 pointer-coarse:after:min-w-11 [&_svg:not([class*='opacity-'])]:opacity-80 [&_svg:not([class*='size-'])]:size-5",
  {
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
    variants: {
      size: {
        sm: 'p-1',
        default: 'p-2',
        lg: 'p-3',
      },
      variant: {
        default: '',
        outline: 'border-border border',
      },
    },
  },
)

function Toggle({
  className,
  variant,
  size,
  children,
  ...props
}: TogglePrimitive.Props & VariantProps<typeof toggleVariants>) {
  const wrappedChildren = Children.map(children, (child) =>
    typeof child === 'string' ? (
      <span className="element">{child}</span>
    ) : (
      child
    ),
  )

  return (
    <TogglePrimitive
      className={cn(toggleVariants({ size, variant }), className)}
      data-slot="toggle"
      {...props}
    >
      {wrappedChildren}
    </TogglePrimitive>
  )
}

export { Toggle, toggleVariants }
